import { getDurationInMs } from "@trainline-shareable/utils";
import isSameLocation from "./isSameLocation";
const getLegConnection = (legId, legs) => {
  const idx = legs.findIndex((leg) => leg.id === legId);
  if (idx === -1 || idx + 1 >= legs.length)
    return void 0;
  const currLeg = legs[idx];
  const nextLeg = legs[idx + 1];
  const durationInMs = getDurationInMs(currLeg.localArriveAt, nextLeg.localDepartAt);
  const isSameStation = isSameLocation(currLeg.destination, nextLeg.origin);
  return { durationInMs, isSameStation };
};
var getLegConnection_default = getLegConnection;
export {
  getLegConnection_default as default
};
